/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import {
  Row,
  Col
} from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import tablePaquetes from '../../views/paquetes/paquetes.table';
import { v4 as uuidv4 } from 'uuid';
import notification from '../notification.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import detalleFunction from '../../views/detalle/detalle.function';
import tableDetalle from '../../views/detalle/detalle.table';
import { ConfigContextUtils } from '../../context/contextUtils.context';

const DetalleMod = ({ data, onClose, onUpdate }) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const [productosWait, setProductosWait] = useState({
    cantidad: '',
    descripcion: '',
    uuid: null,
  });
  const [productos, setProductos] = useState([]);

  const modificarDetalle = () => {
    if (productos.length) {
      setPreloader(true);
      detalleFunction.detalle({ guia_id: data.id, detalle: productos }).then((respuesta) => {
        if (respuesta.detalle_actualizado) {
          notification.success();
          onUpdate();
          onClose();
         } else {
          notification.waring('Los bultos no fueron actualizados');
         }
         setPreloader(false);
      })
    } else {
      notification.warning('Debe completar los campos para agregar un detalle');
    }
  }

  useEffect(() => {
    setProductos(data.detalle)
  },[])
  
  const setValuesProductos = (element) => {
    setProductosWait({
      ...productosWait,
      [element.target.name]: element.target.value,
      uuid: uuidv4(),
    })
  }

  const agregarProductos = () => {
    if (productosWait.cantidad !== '' && productosWait.descripcion.trim() !== '') {
       setProductos([
        {...productosWait},
         ...productos,
       ]);
       setProductosWait({cantidad: '', descripcion_productos: '', uuid: null});
    } else {
      notification.warning('Debe completar los campos para agregar un producto');
    }
  }

  const removeProducto = (row) => {
    const index = productos.findIndex((e) => e.uuid === row.uuid);
    const updateElement = [...productos];
    updateElement.splice(index, 1);
    setProductos(updateElement);
  }
  
  return (
    <>
      <Row>
        <Col>
          <div className="grupo-input">
            <small>Cantidad</small>
            <input type="text"
              className={`form-control input-border`}
              name="cantidad"
              onChange={setValuesProductos}
              value={productosWait.cantidad}
              />
          </div>
        </Col>
        <Col lg={10}>
          <div className="grupo-input">
            <small>Descripción</small>
            <div className="d-flex">
              <input type="text"
                className={`form-control input-border`}
                name="descripcion"
                onChange={setValuesProductos}
                value={productosWait.descripcion}
                />
              <button onClick={agregarProductos} type="button" className="btnx btnx-warn icon-table">
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>
          </div>
        </Col>
       </Row>
       <Row>
        <Col>
           <DataTable
            title="Detalle productos"
            customStyles={tablePaquetes.customStyles}
            columns={tableDetalle.colummnsWithFunc2(removeProducto)}
            data={productos}
            dense={true}
            pagination={true}
            paginationPerPage={10}
          />
        </Col>
       </Row>
       <Row>
          <Col className="d-flex justify-content-end mt-3">
            <button onClick={modificarDetalle} type="button" className="btnx btnx-warn mr-2">Guardar</button>
            <button onClick={() => onClose()}  type="button" className="btnx btnx-warn">Cancelar</button>
          </Col>
        </Row>
    </>
  )
}

export default DetalleMod;